import { createReducer } from 'redux-act';

import * as actions from '../actions/zipCode';

const DEFAULT_STATE = {
  status: false,
  attempt: 0,
  maxAttempts: 0,
  prevalidationLoading: false,
  validationLoading: false
};

export default createReducer(
  {
    [actions.setZipCodeInfo]: (
      state,
      { status = state.status, attemptsAllowed, attemptsLeft }
    ) => ({
      ...state,
      status,
      maxAttempts: attemptsAllowed,
      attempt: attemptsAllowed - attemptsLeft
    }),
    [actions.setZipCodePreValidationLoading]: (
      state,
      prevalidationLoading
    ) => ({
      ...state,
      prevalidationLoading
    }),
    [actions.setZipCodeValidationLoading]: (state, validationLoading) => ({
      ...state,
      validationLoading
    }),
    [actions.zipCodeReset]: () => ({ ...DEFAULT_STATE })
  },
  DEFAULT_STATE
);
